var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderplaced(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7046 72.5699L77.49 37.4897L71.8359 31.9116L42.7046 61.2897L27.9546 46.4147L22.4234 51.9928L42.7046 72.5699ZM49.9567 99.5928C43.2373 99.5928 36.8866 98.2912 30.9046 95.6881C24.9227 93.085 19.6987 89.5315 15.2327 85.0277C10.7668 80.5239 7.24316 75.2557 4.66191 69.223C2.08066 63.1904 0.790039 56.7859 0.790039 50.0095C0.790039 43.1505 2.08066 36.7046 4.66191 30.672C7.24316 24.6393 10.7668 19.3918 15.2327 14.9293C19.6987 10.4668 24.9227 6.93396 30.9046 4.33083C36.8866 1.72771 43.2373 0.426147 49.9567 0.426147C56.7581 0.426147 63.1498 1.72771 69.1317 4.33083C75.1137 6.93396 80.3171 10.4668 84.7421 14.9293C89.1671 19.3918 92.6702 24.6393 95.2515 30.672C97.8327 36.7046 99.1234 43.1505 99.1234 50.0095C99.1234 56.7859 97.8327 63.1904 95.2515 69.223C92.6702 75.2557 89.1671 80.5239 84.7421 85.0277C80.3171 89.5315 75.1137 93.085 69.1317 95.6881C63.1498 98.2912 56.7581 99.5928 49.9567 99.5928Z",
    fill: "#13DA27"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderplaced);
export default __webpack_public_path__ + "static/media/orderplaced.e3de11a31f757cd398f873b3c808bd06.svg";
export { ForwardRef as ReactComponent };